import * as React from 'react';
import { v2 } from '@fieldnation/platform-components';
import BackoutScore from '../index';
import CloseButton from '../../common/components/CloseButton';
import { IReliabilityScore, ScoreType } from './types.d';

const { Modal } = v2;

interface BackOutDetailsProps {
  isOpen: boolean;
  onClose: () => void;
  providerId: number;
  reliabilityScore: IReliabilityScore;
}

export default function BackOutDetails(props: BackOutDetailsProps): JSX.Element {
  const {
    isOpen, onClose, providerId, reliabilityScore,
  } = props;
  const backoutScorePayload = reliabilityScore?.[ScoreType.Cancellation] ?? {};
  return (
    <Modal
      isOpen={isOpen}
      header="Backout details"
      onClose={onClose}
      size="medium"
      position="center"
    >
      <BackoutScore workOrderData={backoutScorePayload} providerId={providerId} />
      <CloseButton onClose={onClose} />
    </Modal>
  );
}
